/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WriteOnlyUserHasMonitoredObjectGroup
 */
export interface WriteOnlyUserHasMonitoredObjectGroup {
    /**
     * 
     * @type {string}
     * @memberof WriteOnlyUserHasMonitoredObjectGroup
     */
    id?: string;
    /**
     * 
     * @type {number}
     * @memberof WriteOnlyUserHasMonitoredObjectGroup
     */
    monitoredObjectGroup: number;
    /**
     * 
     * @type {number}
     * @memberof WriteOnlyUserHasMonitoredObjectGroup
     */
    user: number;
}

export function WriteOnlyUserHasMonitoredObjectGroupFromJSON(json: any): WriteOnlyUserHasMonitoredObjectGroup {
    return WriteOnlyUserHasMonitoredObjectGroupFromJSONTyped(json, false);
}

export function WriteOnlyUserHasMonitoredObjectGroupFromJSONTyped(json: any, ignoreDiscriminator: boolean): WriteOnlyUserHasMonitoredObjectGroup {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'monitoredObjectGroup': json['monitored_object_group'],
        'user': json['user'],
    };
}

export function WriteOnlyUserHasMonitoredObjectGroupToJSON(value?: WriteOnlyUserHasMonitoredObjectGroup | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'monitored_object_group': value.monitoredObjectGroup,
        'user': value.user,
    };
}


